import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { TenantIdService } from "./tenant-id.service";
import { Observable } from "rxjs";
import { map, share, switchMap } from "rxjs/operators";
import { environment as env } from 'src/environments/environment';


export abstract class BaseService {
    tenantUrl: Observable<string>;

    private static readonly clientId = 'LM-8CB26164-F2C5-41F3-AFD6-0F293650EC3F';

    constructor(
        protected tenantIdService: TenantIdService,
        private httpClient: HttpClient,
    ) {

        this.tenantUrl = tenantIdService.tenantId
            .pipe(
                map(tenantInfo => 
                    (tenantInfo.name != '' && tenantInfo.source == 'subdomain')
                    ? env.urlSchema + tenantInfo.name + '.' + env.apiUrlPartial
                    : env.urlSchema + env.apiUrlPartial),
                share()
            );
    }

    protected getHeaders() {
        return this.tenantIdService.tenantId
            .pipe(
                map(tenantInfo => new HttpHeaders()
                    .append('X-Tenant', tenantInfo.name)
                    .append('X-ClientId', BaseService.clientId)
                )
            );
    }

    protected getDefaultOptions() {
        return this.getHeaders()
            .pipe(
                map(headers => ({ headers }))
            );
    }

    protected apiPost<T>(url: string, payload: any) {
        return this.getDefaultOptions()
            .pipe(
                switchMap(options => this.httpClient.post<T>(url, payload, options))
            );
    }

    protected apiGet<T>(url: string, params?: HttpParams) {
        return this.getDefaultOptions()
            .pipe(
                switchMap(options => this.httpClient.get<T>(url, { params, ...options }))
            );
    }

    protected apiGetWithResponse<T>(url: string, params?: HttpParams): Observable<HttpResponse<T>> {
        return this.getDefaultOptions()
            .pipe(
                switchMap(options => this.httpClient.get<T>(url, { params, observe: 'response', ...options }))
            );
    }

    protected apiPut<T>(url: string, payload: T) {
        return this.getDefaultOptions()
            .pipe(
                switchMap(options => this.httpClient.put<T>(url, payload, options))
            );
    }

    protected apiDelete(url: string) {
        return this.getDefaultOptions()
            .pipe(
                switchMap(options => this.httpClient.delete(url, options))
            );
    }
}
